import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { advisorAdminApi } from '../api/api';

export function useUpdateFeatureFlags() {
  const mutation = useMutation({
    mutationFn: ({ advisorId, featureFlags }: { advisorId: string; featureFlags: string }) =>
      advisorAdminApi.updateAdvisorField(advisorId, {
        advisorFieldKey: 'featureFlags',
        advisorFieldValue: featureFlags,
      }),
    onSuccess: () => {
      toast.success('Feature flags updated successfully');
    },
  });

  return {
    updateFeatureFlags: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
}
